import React, { Component } from 'react'
import {Container,Row, Card ,Col } from 'reactstrap'
import { Modal, Button } from "react-bootstrap";
import {Link} from 'react-router-dom'
import {API_CANDIDATE} from "../../utils/config"
import {viewMatchedJobs,searchMatchedJobs } from "../../redux/action/jobs/matchedJobsAction"
import ErrorNotifier from '../aside/ErrorNotifier';
import Notifier from '../aside/Notifier';
import { connect } from 'react-redux'
import axios from 'axios'

import ParticularMatchedJobs from "./particular_matched_jobs"
import { Hidden } from '@material-ui/core';


 class MatchedJobs extends Component {
     constructor(){
     super()
     this.state = {
      data:[],
      store:[],
      edit:false,
      storeData:[],
      searchValue:"",
      errorSearch:"" 
     }  
     this.handleViewClick = this.handleViewClick.bind(this)
     this.backNavigate = this.backNavigate.bind(this)
     this.searchChange = this.searchChange.bind(this)
     this.searchClick = this.searchClick.bind(this)  
     }

    componentDidMount(){
     this.getData()

    }

  
  componentDidUpdate(prevProps,prevState){
   if(prevState.data !== this.state.data){
     let body = {
        primarySkills:this.state.store.toString()
     }
      this.props.viewMatchedJobs(body)
  
    }
    else if(!this.state.searchValue) {
     if(prevState.searchValue !== this.state.searchValue){
      let body = {
        primarySkills:this.state.store.toString()
     } 
      this.props.viewMatchedJobs(body)
     }

    }
    
    
    }

     getData() {
       axios
          .get(`${API_CANDIDATE}/v1/api/can-primary-skill`, { withCredentials: true })
          .then((res) => {
            console.log(res);
           this.setState({
              data: res.data,
            });
          })
          .catch((err) => {
            console.log("err", err);
          });
      }

      searchChange(e){
        if(!e.target.value){
        this.props.viewMatchedJobs()  
        }
      this.setState({
        [e.target.name]:e.target.value,
        errorSearch:""
      })
      }

      searchClick(){
        if(this.state.searchValue){
          let body = {
            search:this.state.searchValue
          }
        this.props.searchMatchedJobs(body)
        }
        else {
         this.setState({
           errorSearch:"Please enter keyword to search"
         })
        }
       
      }

      handleViewClick(data){
        this.setState({
        isEdit:!this.state.isEdit,     
        storeData:[data],
        })
    
         }
    
         backNavigate(){
            this.setState({
                isEdit:false,     
             })
        }
    render() {
      console.log(this.props.MatchedJobs)
                 for(let i = 0 ; i < this.state.data.length ; i++){
                    this.state.store.push(this.state.data[i].skill)
                   }
          return (
            <div>
          <Container
            style={{ width:"80%", marginTop: "40px !important" 
          }}
            className="card container-card migrator-mt personalDetails-div-1"
          >
            <Link to = "/dashboard">
            <i
              className="material-icons contact-cancel-button pointer">
              cancel
            </i>
           
            </Link>
            <Row className='scrollmenu'>
            { !this.state.isEdit &&  <div
            style={{
              height: "50px",
              width: "60%",
              margin: "auto",
              marginTop: "1rem",
            }}
            class="search-container"
          >
            <div style={{ display: "flex", height: "100%", width: "100%" }}>
              <input
                className="input-candisearch"
                value={this.state.searchValue}
                name="searchValue"
                style={{ width: "100%", height: "100" }}
                onChange={this.searchChange}
                onKeyPress={(e) => {
                  if (e.code === "Enter") {
                  this.searchClick();
                  }
                  }}
                type="text"
                placeholder="Search.."
              
              />
              <button
                onClick={this.searchClick}
                style={{ border: "none", background: "green", width: "80px" }}
                type="submit"
              >
                <i style={{ color: "white" }} class="fa fa-search"></i>
              </button>
            </div>
            <span style={{ fontSize: "14px", color: "red" }}>
              {this.state.errorSearch}
            </span>
            <span style={{ fontSize: "14px", color: "red" }}>
              {this.props.MatchedJobs.message}
            </span> 
          </div>}

           <Row style={{marginTop:"1rem"}} >
           { !this.state.isEdit && <Col md="12" className="p-0">
              <ul className="crm-flex-around  ul-head ">
                <li
                  style={{ width: "10%",  fontSize: "14px",
                  fontWeight: "500", }}
                  className="list-crm-item bold pad-rs-name margin_res"
                >
                   Id
                </li>
                <li  style={{fontSize: "14px",
                  fontWeight: "500",width:"10%" }} className="list-crm-item bold pad-rs-name margin_res"> Req Id</li>
                <li style={{fontSize: "14px",
                  fontWeight: "500",}} className="list-crm-item bold pad-rs-name margin_res">Job Category</li>
                <li style={{fontSize: "14px",
                  fontWeight: "500" }} className="list-crm-item bold pad-rs-name margin_res"> Job Position</li>

                <li style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res">Job Location</li>
               
                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res"> Experience</li>

                <li  style={{
                  
                  fontSize: "14px",
                  fontWeight: "500",
                }} className="list-crm-item bold pad-rs-name margin_res"> Skills</li>
                <li
                   style={{
                  
                    fontSize: "14px",
                    fontWeight: "500",
                  }}
                  className="list-crm-item bold pad-rs-name margin_res"
                >
                  {" "}
                  Qualification
                </li>
              </ul>
            </Col>}
            </Row>
           { !this.state.isEdit && this.props.MatchedJobs.data.length > 0 &&
               this.props.MatchedJobs.data.map((item) => {
                return (
                  <Col md="12" className="p-0" key={item.id}>
                    <ul
                      onClick={() => this.handleViewClick(item)}
                      className="rs-flex-around margin_ul"
                      // onClick={() => {
                      //   select(item);
                      // }}

                      // onMouseEnter={(e) => this.toggleHoverOn(e, item)}
                      // onMouseLeave={this.toggleHoverOff}
                    >
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.id}
                      </li>
                      <li
                        style={{ width: "10%", paddingLeft: "2%" }}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobRequirement}
                      </li>
                      <li
                      style={{overflow:"strink"}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobCategory}
                      </li>
                     
                      <li
                        style={{}}
                        className="list-crm-table-item pad-rs-name margin_res margin_ul overlap_text"
                      >
                        {item.jobPosition}
                      </li>

                      <li
                         style={{overflow:'Hidden'}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.jobLocation}
                      </li>
                     
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.minYearsOfExp}
                      </li>
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.primarySkills}
                      </li>
                      <li
                         style={{}}
                        className="list-crm-table-item pad-rs-name margin_res overlap_text"
                      >
                        {item.qualifications}
                      </li>
                    </ul>
                  </Col>
                 
                );
              })}
          </Row>
          {this.props.ApplyJobs.message ? (
          <Notifier message={this.props.ApplyJobs.message} />
        ) : null}

       {this.props.ApplyJobs.error ? (
          <ErrorNotifier message={this.props.ApplyJobs.error} />
        ) : null}
          {
          this.state.isEdit && <ParticularMatchedJobs back ={this.backNavigate} storeData = {this.state.storeData}/>
          }

        {this.props.MatchedJobs.message && <ErrorNotifier message={this.props.MatchedJobs.message} />}
          </Container>  
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    MatchedJobs:state.MatchedJobs,
    ApplyJobs: state.ApplyJobs,
})


export default connect(mapStateToProps,{
viewMatchedJobs,
searchMatchedJobs 
})(MatchedJobs)
